import axios from 'axios'
import qs from 'qs'
import store from 'storejs'
import { Toast, MessageBox } from 'mint-ui';
import { getUrlParam } from '../../common/utils/url'
import { apiUrl } from  './constant'
import * as plantform from '@/common/utils/plantform';
class BaseService {
  constructor() {
    var CancelToken = axios.CancelToken;
    var source = CancelToken.source();
    const appencrypt = getUrlParam('appencrypt');
    let nxt = store.get('nxt') || {};
    let encrypt = nxt.encrypt;
    this.encrypt = encrypt;
    if(appencrypt && !plantform.isWechat) {
    //   this.getEncrypt(appencrypt).then(res=> {
    //     nxt = Object.assign(nxt,{ encrypt: res.encrypt, userId: res.data.userId });
    //     encrypt = res.encrypt;
    //     
    //   });
      store({ nxt });
    }
    this.isVisitor = !!getUrlParam('shareEncrypt') && !getUrlParam('appencrypt') && !nxt.encrypt;
    this.shareEncrypt = !!getUrlParam('shareEncrypt') ? decodeURIComponent(getUrlParam('shareEncrypt')) : null;
    this.$http = axios.create({
      timeout: 5000,
      baseURL: apiUrl,
      headers: {
        encrypt: encrypt || '',
        'Content-Type':'application/json',
        companyCode: 'NXT-GS',
        areaCode: 'NXT'
      },
      cancelToken: source.token,
      withCredentials: apiUrl === 'https://merch.yishengzhan.cn/api/' ? true : false,
      transformRequest: [function (data, headers) {
        let nxt = store.get('nxt') || {};
        let encrypt = nxt.encrypt;
        console.log('headers',headers);
        headers.encrypt=encrypt || "";
        // Do whatever you want to transform the data
        return JSON.stringify(data);
      }],
      transformResponse: [function (data) {
        // Do whatever you want to transform the data
        return data;
      }],
    })


    this.$http.interceptors.request.use(request => {
      if(!request.headers.encrypt){
        const nxt = store.get('nxt') || {};
        const encrypt = getUrlParam('encrypt') || nxt.encrypt;
        request.headers.encrypt = encrypt
      }
      return request
    })

    this.$http.interceptors.response.use(response => {
        const data =  JSON.parse(response.data)
        if(data.code === 0 && !this.isVisitor){
          Toast(data.msg)
          console.log(data.msg);
          return Promise.reject(data);
        }
      return JSON.parse(response.data)
    }, err => {
      // Toast('网络错误')
      if(appencrypt) {
        this.updateEncrypt(encrypt)
      }
    })
  }

  updateEncrypt(encrypt) {
    this.$http.defaults.headers.encrypt = encrypt
  }

  // confirmLogin() {
  //   MessageBox({
  //     title: '提示',
  //     message: '您还没有登录，是否去登录？',
  //     confirmButtonText: '确定',
  //     cancelButtonText: '取消',
  //     confirmButtonClass: 'red',
  //     showCancelButton: true,
  //     closeOnClickModal: false
  //   })
  //   .then(action => {
  //     if(action === 'confirm') {
  //       // const from = encodeURIComponent(this.$route.fullPath)
  //       location.hash = '#/agree';
  //       // this.$router.push({ path:'agree', query: { from } })
  //     }
  //   })
  // }

  pureParams(params) {
    Object.keys(params).forEach(item => !params[item] && delete params[item]);
    return params;
  }

  async getEncrypt (appencrypt) {
    try {
      const isWechat = plantform.isWechat;
      const system = plantform.system;
      const response = await axios.post('/accounts/login',  {
        areaCode:'NXT',
        platform: isWechat ? 'WX' : system,
        appencrypt,
        companyCode: 'NXT-GS'
      }, { baseURL: apiUrl })
      const data = response.data
      this.encrypt = data.encrypt;
      return data;
    } catch (e) {
      console.log(e)
    }
  }

  get(url, config = {}) {
    return this.$http.get(url, config)
  }

  post(url, data = undefined, config = {}) {
    return this.$http.post(url, data, { ...this.dataMethodDefaults, ...config })
  }

  put(url, data = undefined, config = {}) {
    return this.$http.put(url, data, { ...this.dataMethodDefaults, ...config })
  }

  delete(url, config = {}) {
    return this.$http.delete(url, config)
  }
}

export default BaseService;



// WEBPACK FOOTER //
// ./src/common/base/baseService.js